<template>
  <vk-modal
      @close="$router.replace({ name: 'pro-public-profile', params: $route.params })">
    <vk-modal-body class="MODAL-BODY">
      <vk-modal-header>
        <div class="d-flex text-bold ai-center">
          Pro Credentials
        </div>
      </vk-modal-header>
      <vk-modal-content>
        <div class="CREDENTIAL-SECTION">
          <div class="CREDENTIAL-HEADER">
            <span class="CREDENTIAL-TITLE">Background Check</span>
            <vk-icon
                :class="{ 'ROTATE': !isActiveSectionBackground }"
                class="h4 c-depot cur-pointer"
                name="chevronup"
                @click.native="toggleSection('background')"/>
          </div>
          <div v-show="isActiveSectionBackground" class="p-l-5">
            Pro Referral conducts an initial background check on the owner or principal of
            each Pro’s business to ensure they meet our standards for eligibility. This
            criminal search background screening is repeated periodically to monitor status.
          </div>
        </div>

        <div class="CREDENTIAL-SECTION">
          <div class="CREDENTIAL-HEADER">
            <span class="CREDENTIAL-TITLE">License Information</span>
            <vk-icon
                :class="{ 'ROTATE': !isActiveSectionLicense }"
                class="h4 c-depot cur-pointer"
                name="chevronup"
                @click.native="toggleSection('license')"/>
          </div>
          <div v-show="isActiveSectionLicense" class="p-l-5">
            Trade licensing requirements vary by location. Some types of work may require
            additional levels of licensing or certification. Be sure to verify a Pro’s licensing
            is adequate and valid before starting your project.
            <div v-if="profile.licenseInfo.isLicensed">
              <div
                  v-for="(license, index) in profile.licenseInfo.licenses"
                  :key="index"
                  class="c-depot m-t-1">
                {{ index+1 }}. License expires on {{ license.end_date | formatDate('MM/dd/yyyy') }}
              </div>
            </div>
          </div>
        </div>

        <div class="CREDENTIAL-SECTION">
          <div class="CREDENTIAL-HEADER">
            <span class="CREDENTIAL-TITLE">Insurance Coverage</span>
            <vk-icon
                :class="{ 'ROTATE': !isActiveSectionInsurance }"
                class="h4 c-depot cur-pointer"
                name="chevronup"
                @click.native="toggleSection('insurance')"/>
          </div>
          <div v-show="isActiveSectionInsurance" class="p-l-5">
            Insurance coverage is reported by the Pro to meet Pro Referral’s requirements.
            To verify a Pro is adequately insured, be sure to request proof of coverage
            before starting your project.
            <div v-if="profile.insuranceInfo.amount" class="c-depot m-t-1">
              Policy Limit: ${{ profile.insuranceInfo.amount | formatNumber }}
            </div>
            <div v-if="profile.insuranceInfo.amount" class="text-sm m-t-1">
              Insurance information is provided to Pro Referral by the pro.
            </div>
          </div>
        </div>
        <div v-if="profile.topPro !== null" class="CREDENTIAL-SECTION">
          <div class="CREDENTIAL-HEADER">
            <span class="CREDENTIAL-TITLE">Top Pro</span>
            <vk-icon
                :class="{ 'ROTATE': !isActiveSectionTopPro }"
                class="h4 c-depot cur-pointer"
                name="chevronup"
                @click.native="toggleSection('top-pro')"/>
          </div>
          <div v-show="isActiveSectionTopPro" class="p-l-5">
            Top Pros have shown consistent, high quality performance verified
            by Pro Referral every 30 days.
            Top Pros maintain superb review scores while keeping high
            job response and acceptance rates.
          </div>
        </div>
        <div class="CREDENTIAL-SECTION">
          <div class="CREDENTIAL-HEADER">
            <span class="CREDENTIAL-TITLE">5 Star</span>
            <vk-icon
                :class="{ 'ROTATE': !isActiveSectionFiveStar}"
                class="h4 c-depot cur-pointer"
                name="chevronup"
                @click.native="toggleSection('five-star')"/>
          </div>
          <div v-show="isActiveSectionFiveStar" class="p-l-5">
            5-Star Pros maintain the highest possible review scores.These Pros have
            demonstrated their ability to provide highly approved work for their customers.
          </div>
        </div>
      </vk-modal-content>
    </vk-modal-body>
  </vk-modal>
</template>

<script>
export default {
  name: 'credentials-modal',
  props: {
    profile: {
      type: Object,
      required: true,
    },
    section: {
      type: String,
      default () {
        return 'background';
      },
      validator (value) {
        return ['background', 'license', 'insurance', 'top-pro', 'five-star'].indexOf(value) !== -1;
      },
    },
  },
  data () {
    return {
      activeSection: '',
    };
  },
  computed: {
    isActiveSectionBackground () {
      return this.activeSection === 'background';
    },
    isActiveSectionLicense () {
      return this.activeSection === 'license';
    },
    isActiveSectionInsurance () {
      return this.activeSection === 'insurance';
    },
    isActiveSectionTopPro () {
      return this.activeSection === 'top-pro';
    },
    isActiveSectionFiveStar () {
      return this.activeSection === 'five-star';
    },
  },
  watch: {
    section: {
      handler (newVal) {
        this.activeSection = newVal;
      },
      immediate: true,
    },
  },
  methods: {
    toggleSection (section) {
      this.activeSection = this.activeSection === section ? '' : section;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools.scss";

  .MODAL-BODY {
    @include tablet {
      width: 700px!important;
    }
  }

  .CREDENTIAL-SECTION {
    @include padding-bottom(1);
    @include margin-bottom(2);
    border-bottom: 1px solid $color-gray40;
  }

  .CREDENTIAL-HEADER {
    @include margin-bottom(1);
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
    align-items: center;
  }

  .CREDENTIAL-TITLE {
    @include padding-left(2);
    @include h6();
    color: black;
  }

  .ROTATE {
    transform: rotate(180deg);
  }
</style>
